import { render, staticRenderFns } from "./NotificationDropDown.vue?vue&type=template&id=373266c0&"
import script from "./NotificationDropDown.vue?vue&type=script&lang=js&"
export * from "./NotificationDropDown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/otavio.cardoso.neto/Workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('373266c0')) {
      api.createRecord('373266c0', component.options)
    } else {
      api.reload('373266c0', component.options)
    }
    module.hot.accept("./NotificationDropDown.vue?vue&type=template&id=373266c0&", function () {
      api.rerender('373266c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/layouts/components/navbar/components/NotificationDropDown.vue"
export default component.exports